import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["videoId", "onPlay", "userActivityData", "videoAnalyticsData"];
import { forwardRef, useEffect, useMemo, useRef } from 'react';
import { trackUserActivity, UserActivityEvent } from '@crehana/analytics';
import CrehanaPlayerClass from "../CrehanaPlayerClass";
import CrehanaPlayerWithVideoAnalytics from "./CrehanaPlayerWithVideoAnalytics";
import { jsx as _jsx } from "react/jsx-runtime";
var CrehanaPlayerWithUserActivity = function CrehanaPlayerWithUserActivity(_ref, ref) {
  var videoId = _ref.videoId,
    onPlayProp = _ref.onPlay,
    userActivityData = _ref.userActivityData,
    videoAnalyticsData = _ref.videoAnalyticsData,
    crehanaPlayerProps = _objectWithoutProperties(_ref, _excluded);
  var platform = (userActivityData === null || userActivityData === void 0 ? void 0 : userActivityData.appPlatform) || 'web';
  var commonEventData = useMemo(function () {
    return {
      user: userActivityData.user,
      jwtToken: userActivityData.jwtToken,
      data: {
        product_id: userActivityData.course.originalId,
        product_name: userActivityData.course.title,
        app_platform: platform,
        item_type: 'course'
      }
    };
  }, [userActivityData.user, userActivityData.jwtToken, userActivityData.course.originalId, userActivityData.course.title, platform]);
  var shouldTrackFirstPlayEvent = useRef(true);

  // biome-ignore lint/correctness/useExhaustiveDependencies: dependencies are intentional
  useEffect(function () {
    shouldTrackFirstPlayEvent.current = true;
  }, [videoId]);
  var onPlay = function onPlay(params) {
    if (shouldTrackFirstPlayEvent.current) {
      trackUserActivity(_objectSpread(_objectSpread({}, commonEventData), {}, {
        event: UserActivityEvent.FIRST_PLAY
      }));
      shouldTrackFirstPlayEvent.current = false;
    }
    if (onPlayProp) {
      onPlayProp(params);
    }
  };
  var forwardedProps = _objectSpread({
    ref: ref,
    videoId: videoId,
    onPlay: onPlay
  }, crehanaPlayerProps);
  if (videoAnalyticsData) {
    return /*#__PURE__*/_jsx(CrehanaPlayerWithVideoAnalytics, _objectSpread({
      videoAnalyticsData: videoAnalyticsData
    }, forwardedProps));
  }
  return /*#__PURE__*/_jsx(CrehanaPlayerClass, _objectSpread({}, forwardedProps));
};
export default /*#__PURE__*/forwardRef(CrehanaPlayerWithUserActivity);